<template>
  <div
    class="cover"
    @click="next"
    :style="{ backgroundImage: `url('${getMainPage.cover}')` }">
  </div>
</template>

<script>
export default {
  name: 'CollectionCover',
  props: [
    'locale',
    'lang',
    'pageId',
    'categoryId'
  ],
  computed: {
    getMainPage () {
      return this.$store.getters['collection/getCollectionMainPage']
    },
  },
  created () {
  },
  data () {
    return {
    }
  },
  methods: {
    next () {
      this.$emit('hideCover')
    }
  }
}
</script>